import { render, staticRenderFns } from "./VgPicker.vue?vue&type=template&id=6ea003f2&scoped=true&"
import script from "./VgPicker.vue?vue&type=script&lang=js&"
export * from "./VgPicker.vue?vue&type=script&lang=js&"
import style0 from "./VgPicker.vue?vue&type=style&index=0&id=6ea003f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea003f2",
  null
  
)

export default component.exports